var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { camelCase } from "lodash";
import { appEmbedConverter } from "./nodes/app-embed-converter";
import { audioConverter } from "./nodes/audio-converter";
import { blockquoteConverter } from "./nodes/blockquote-converter";
import { bulletedListConverter } from "./nodes/bulleted-list-converter";
import { actionButtonConverter, linkButtonConverter } from "./nodes/button-converters";
import { codeBlockConverter } from "./nodes/code-block-converter";
import {
  collapsibleItemBodyConverter,
  collapsibleItemConverter,
  collapsibleItemTitleConverter,
  collapsibleListConverter
} from "./nodes/collapsible-list-converters";
import { dividerConverter } from "./nodes/divider-converter";
import { embedConverter } from "./nodes/embed-converter";
import { externalConverter } from "./nodes/external-converter";
import { fileUploadConverter } from "./nodes/file-upload-converter";
import { galleryConverter } from "./nodes/gallery-converter";
import { gifConverter } from "./nodes/gif-converter";
import { headingConverter } from "./nodes/heading-converter";
import { htmlConverter } from "./nodes/html-converter";
import { imageConverter } from "./nodes/image-converter";
import { linkPreviewConverter } from "./nodes/link-preview-converter";
import { listItemConverter } from "./nodes/list-converters";
import { mapConverter } from "./nodes/map-converter";
import { orderedListConverter } from "./nodes/ordered-list-converter";
import { paragraphConverter } from "./nodes/paragraph-converter";
import { pollConverter } from "./nodes/poll-converter";
import {
  tableConverter,
  tableHeaderCellConverter,
  tableRowConverter
} from "./nodes/table-converters";
import { textConverter } from "./nodes/text-converter";
import { videoConverter } from "./nodes/video-converter";
const getUnsupportedToTiptap = (node) => {
  const dataProp = Object.keys(node).find((p) => p.endsWith(`${camelCase(node.type)}Data`));
  return {
    types: [node.type],
    convert: (node2, visit) => {
      const content = visit(node2);
      return __spreadValues({
        type: node2.type,
        attrs: __spreadProps(__spreadValues({}, dataProp ? node2[dataProp] : {}), {
          id: node2.id
        })
      }, content.length > 0 ? { content } : {});
    }
  };
};
const getUnsupportedFromTiptap = (node) => {
  const _a = node.attrs || {}, { id } = _a, data = __objRest(_a, ["id"]);
  return {
    types: [node.type],
    convert: (node2, visit) => ({
      type: node2.type,
      id,
      [`${camelCase(node2.type)}Data`]: __spreadValues({}, data),
      nodes: visit(node2)
    })
  };
};
const nodeConverters = [
  imageConverter,
  dividerConverter,
  textConverter,
  paragraphConverter,
  blockquoteConverter,
  headingConverter,
  linkButtonConverter,
  actionButtonConverter,
  listItemConverter,
  collapsibleListConverter,
  collapsibleItemConverter,
  collapsibleItemTitleConverter,
  collapsibleItemBodyConverter,
  tableConverter,
  tableRowConverter,
  tableHeaderCellConverter,
  codeBlockConverter,
  audioConverter,
  embedConverter,
  fileUploadConverter,
  galleryConverter,
  gifConverter,
  mapConverter,
  videoConverter,
  pollConverter,
  htmlConverter,
  linkPreviewConverter,
  orderedListConverter,
  bulletedListConverter,
  appEmbedConverter,
  externalConverter
];
export {
  getUnsupportedFromTiptap,
  getUnsupportedToTiptap,
  nodeConverters
};
//# sourceMappingURL=node-converters.js.map
